__turbopack_context__.v({
  "description": "Notification-module__Kxrmda__description",
  "root": "Notification-module__Kxrmda__root",
  "title": "Notification-module__Kxrmda__title",
});
